
/**
 * Clerk Configuration Utility
 * Centralizes the logic for determining if Clerk should be used or if we should fall back to mock mode.
 */

// Static access to VITE_ variables ensures Vite's static replacement works reliably
export const CLERK_PUBLISHABLE_KEY = (import.meta.env?.VITE_CLERK_PUBLISHABLE_KEY as string) || (typeof process !== 'undefined' ? (process.env.VITE_CLERK_PUBLISHABLE_KEY || '') : '');
export const IS_EXPLICIT_MOCK = (import.meta.env?.VITE_USE_MOCKS?.toString()?.toLowerCase() === 'true') || (typeof process !== 'undefined' ? process.env.VITE_USE_MOCKS === 'true' : false);

// A valid Clerk key MUST start with pk_
export const IS_VALID_CLERK_KEY = CLERK_PUBLISHABLE_KEY.startsWith('pk_');

const isPrerendering = typeof window !== 'undefined' && !!(window as any).__PRERENDER_INJECTED?.isPrerendering;

// Mock mode is active ONLY if explicitly requested via VITE_USE_MOCKS.
// We DO NOT fallback to mock mode just because a key is missing, even in development.
// ENFORCEMENT: We allow fallback mock data if VITE_USE_MOCKS is explicitly set.
export const SHOULD_USE_MOCKS = isPrerendering || IS_EXPLICIT_MOCK;
export const ENABLE_HEALTH_CHECKS = (import.meta.env?.VITE_ENABLE_HEALTH_CHECKS === 'true') || (typeof process !== 'undefined' ? process.env.VITE_ENABLE_HEALTH_CHECKS === 'true' : false);

export const clerkConfig = {
  publishableKey: IS_VALID_CLERK_KEY ? CLERK_PUBLISHABLE_KEY : undefined,
  shouldUseMocks: SHOULD_USE_MOCKS
};


